import { ViewModel, View, ObservableArray, DelegatedObservableArrayChangeListenner, ObservableArrayChangeListenner } from "binder"
import { ToolPlaceManipulationView } from "./toolPlaceManipulation-view"
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { distinct, stringIsNullOrEmpty } from "src/common/utilities";
import { ToolModelMultiSelectorViewModel } from "./toolModelMultiSelector";

export class ToolPlaceManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف محل قرارگیری ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.toolPlaces = ObservableArray.create<ToolPlaceHolderType>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolPlaceManipulationView();
    }
    public getTypeId(): string {
        return "VM-61E5E3F7-C149-4834-B7D2-5A94E69842CB"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolPlaces(v: ObservableArray<ToolPlaceHolderType>) { this._toolPlaces = v; } public get toolPlaces(): ObservableArray<ToolPlaceHolderType> { return this._toolPlaces; } private _toolPlaces: ObservableArray<ToolPlaceHolderType>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolPlaceServices/ListAllToolPlaceHolderTypes', {
                FilteringInformation: filteringInformation
            });
            this.toolPlaces.update(...result.ToolPlaceHolderTypes.map((x, i) => {
                let t = new ToolPlaceHolderType(this);
                t.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                t.id = x.Id;
                t.name = x.Name;
                t.code = x.Code;
                t.isMandatory = x.IsMandatory;
                t.typeId = x.TypeId;
                t.typeCode = x.TypeCode;
                t.typeName = x.TypeName;
                t.placeCount = x.PlaceCount;
                return t;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
}

export class ToolPlaceHolderType extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolPlaceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ToolPlaceManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set typeId(v: string) { this._typeId = v; } public get typeId(): string { return this._typeId; } private _typeId: string;
    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName; } private _typeName: string;
    public set typeCode(v: string) { this._typeCode = v; } public get typeCode(): string { return this._typeCode; } private _typeCode: string;
    public set placeHolderType(v: string) { this._placeHolderType = v; } public get placeHolderType(): string { return this._placeHolderType; } private _placeHolderType: string;
    public set placeCount(v: string) { this._placeCount = v; } public get placeCount(): string { return this._placeCount; } private _placeCount: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set isMandatory(v: boolean) { this._isMandatory = v; } public get isMandatory(): boolean { return this._isMandatory; } private _isMandatory: boolean;

    async showStructure() {
        let toolPlaceStructure = new ToolPlaceStructureViewModel(this);
        await toolPlaceStructure.loadById(this.id);
        let result = await this.requestShowingPopup(toolPlaceStructure);
        if (result == 'done') {
            this._typedParent.dataLoader.refresh();
        }
    }
}

export class ToolPlaceStructureViewModel extends ViewModel implements IPopup {
    public getTypeId(): string { return 'toolplace-structure'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.singleToolPlaces = ObservableArray.create<SingleToolPlace>();
    }

    private changeListenner: ObservableArrayChangeListenner;
    public set singleToolPlaces(v: ObservableArray<SingleToolPlace>) {
        this._singleToolPlaces = v;

        if (this._singleToolPlaces != null) {
            this._singleToolPlaces.removeChangeListenner(this.changeListenner);
        }
        this._singleToolPlaces = v;
        if (this._singleToolPlaces != null) {
            let listenner = new DelegatedObservableArrayChangeListenner(this, arr => this.listChanged());
            this._singleToolPlaces.addChangeListenner(listenner);
        }

    } public get singleToolPlaces(): ObservableArray<SingleToolPlace> { return this._singleToolPlaces; } private _singleToolPlaces: ObservableArray<SingleToolPlace>;
    public set installableToolModels(v: ObservableArray<InstallableToolModelViewModel>) { this._installableToolModels = v; } public get installableToolModels(): ObservableArray<InstallableToolModelViewModel> { return this._installableToolModels; } private _installableToolModels: ObservableArray<InstallableToolModelViewModel>;
    private _toolPlaceId: string;

    private listChanged() {
        this.singleToolPlaces.forEach((x, i) => x.index = i + 1);
    }

    getToolModelIds(): string[] {
        let single = new SingleToolPlace(this);
        return single.getToolModelIds();
    }

    closePopup(result?: any) {

    }

    back() {
        this.closePopup(null);
    }

    async loadById(toolPlaceHolderTypeId: string) {
        try {
            this._toolPlaceId = toolPlaceHolderTypeId;
            let toolPlaceResult = await ServerConnection.callServer('/Complex/ToolPlaceServices/GetToolPlaceHolderAvailablePlaces', {
                ToolPlaceHolderTypeId: toolPlaceHolderTypeId
            });
            this.singleToolPlaces.update(...toolPlaceResult.ToolPlaces.map((x, i) => {
                let s = new SingleToolPlace(this);
                s.index = i + 1;
                s.id = x.Id;
                s.name = x.Name;
                s.code = x.Code;
                s.comment = x.Comment;
                s.isMandatory = x.IsMandatory;
                s.installableToolModels.update(...x.InstallableToolModels.map((item) => {
                    let i = new InstallableToolModelViewModel(this);
                    i.insallableId = item.InsallableId;
                    i.toolModelId = item.ToolModelId;
                    i.toolModelName = item.ToolModelName;
                    i.toolTypeId = item.ToolTypeId;
                    i.toolTypeName = item.ToolTypeName;
                    return i;
                }));
                s.setToolModelIds(s.installableToolModels.map(item => item.toolModelId));
                return s;
            }));
        } catch (ex) {
            console.log(ex);
        }
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت محل قرارگیری ابزار');
                return;
            } else {
                let canSave = await this.messageBoxWarningYesNo('آیا از ذخیره سازی اطمینان دارید؟', 'ذخیره سازی');
                if (canSave == 'yes') {
                    let result = await ServerConnection.callServer("/Complex/ToolPlaceServices/UpdateToolPlaceHolderAvailablePlaces", {
                        ToolPlaceHolderTypeId: this._toolPlaceId,
                        ToolPlaces: this.singleToolPlaces.map(q => {
                            return {
                                ToolPlaceId: q.id,
                                Name: q.name,
                                Code: q.code,
                                Comment: q.comment,
                                IsMandatory: q.isMandatory,
                                InstallableToolModels: q.toolModelSelector.selectedItems.map(item => item.id)
                            }
                        })
                    });
                    if (result.IsSuccessful == true) {
                        await this.messageBoxConfirmSuccess('ذخیره سازی با موفقیت انجام شد.', 'موفق');
                        this.closePopup('done');
                    }
                    else {
                        await this.messageBoxConfirmWarning("خطا در ثبت محل قرارگیری ابزار", "خطا در عملیات");
                    }
                }
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning("خطا در عملیات ذخیره سازی", "خطا در عملیات");
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (this.singleToolPlaces.filter(x => stringIsNullOrEmpty(x.name)).length > 0) {
            result.push('نام یک یا چند محل ابزار مشخص نشده است.');
        }
        if (this.singleToolPlaces.filter(x => stringIsNullOrEmpty(x.code)).length > 0) {
            result.push('کد یک یا چند محل ابزار مشخص نشده است.');
        }
        // if (this.singleToolPlaces.filter(x => x.toolModelSelector.selectedItems.map(item => item.name).toString())) {
        if (this.singleToolPlaces.filter(x => x.toolModelSelector.selectedItems == null).length > 0) {
            result.push('مدل یک یا چند ابزار مشخص نشده است.');
        }
        let distinctNames = distinct(this.singleToolPlaces.map(x => x.code));
        if (distinctNames.length != this.singleToolPlaces.length) {
            result.push('کد تکراری در محل های ابزار وجود دارد.');
        }
        return result;
    }

    async addToolPlace() {
        let singleToolPlace = new SingleToolPlace(this);
        singleToolPlace.installableToolModels = this.installableToolModels;
        singleToolPlace.index = this.singleToolPlaces.length + 1;
        this.singleToolPlaces.push(singleToolPlace);
    }

    async removeToolPlace(singleToolPlace: SingleToolPlace) {
        this.singleToolPlaces.remove(singleToolPlace);
    }
}

export class SingleToolPlace extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolPlaceStructureViewModel) {
        super(parent);
        this._typedParent = parent;
        this.toolModelSelector = new ToolModelMultiSelectorViewModel(this);
        this.installableToolModels = ObservableArray.create<InstallableToolModelViewModel>();
    }

    private _typedParent: ToolPlaceStructureViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set isMandatory(v: boolean) { this._isMandatory = v; } public get isMandatory(): boolean { return this._isMandatory; } private _isMandatory: boolean;
    public set installableToolModels(v: ObservableArray<InstallableToolModelViewModel>) { this._availableToolPlaces = v; } public get installableToolModels(): ObservableArray<InstallableToolModelViewModel> { return this._availableToolPlaces; } private _availableToolPlaces: ObservableArray<InstallableToolModelViewModel>;
    public set toolModelSelector(v: ToolModelMultiSelectorViewModel) { this._toolModelSelector = v; } public get toolModelSelector(): ToolModelMultiSelectorViewModel { return this._toolModelSelector; } private _toolModelSelector: ToolModelMultiSelectorViewModel;

    setToolModelIds(value: string[]) {
        this.toolModelSelector.selectById(value);
    }
    getToolModelIds(): string[] {
        return this.toolModelSelector.selectedItems.map(x => x.id);
    }

    async remove() {
        this._typedParent.removeToolPlace(this);
    }
}

export class InstallableToolModelViewModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set insallableId(v: string) { this._insallableId = v; } public get insallableId(): string { return this._insallableId; } private _insallableId: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
}
